import { cn, modalWidthClass } from "@/lib/utils";
import Image from "next/image";
import { useRouter } from "next/router";
import { ComponentProps } from "react";

import { MixModal } from "./MixModal";

interface DarkModeReleaseModalProps extends ComponentProps<typeof MixModal> {
    onHideForToday?: () => void;
}

export const DarkModeReleaseModal = ({
    onHideForToday,
    ...props
}: DarkModeReleaseModalProps) => {
    const router = useRouter();

    return (
        <MixModal {...props}>
            <div
                className={cn(
                    `relative flex min-h-[359px] flex-row items-stretch
                    overflow-hidden rounded-small md:min-h-0 md:flex-col`,
                    modalWidthClass
                )}
            >
                {/* Left Side - Moon Icon Section */}
                <Image
                    src="/img/dark-release.webp"
                    alt="다크모드 기능 소개 이미지"
                    className="max-[320px]:h-[359px] max-[320px]:w-[290px]"
                    width={343}
                    height={359}
                />

                {/* Right Side - Content Section */}
                <div
                    className="flex flex-1 flex-col justify-between bg-white
                        px-4 py-8 text-black dark:bg-grey-100 dark:text-white
                        md:py-[15px]"
                >
                    <div className="px-[5px] md:mb-[15px]">
                        {/* Title */}
                        <h2
                            className="m-0 mb-2 text-2xl font-bold leading-[1.3]
                                text-text-primary md:mb-1.5 md:text-xl"
                        >
                            다크모드를 출시하였습니다
                        </h2>

                        {/* Subtitle */}
                        <p
                            className="m-0 mb-2 text-sm font-semibold
                                leading-[1.5] text-text-secondary md:mb-1.5
                                md:text-base"
                        >
                            눈이 편안한 화면으로 믹스를 즐겨보세요
                        </p>
                    </div>

                    <div
                        className="flex flex-col items-start justify-center
                            border-b border-t border-grey-300 px-[5px] py-6
                            md:mb-5 md:border-b-0 md:px-[5px] md:py-5 md:pt-5
                            md:text-[13px]"
                    >
                        <div
                            className="text-base font-light
                                leading-[139.9999976158142%] text-text-primary"
                        >
                            디바이스 설정값에 따라 자동 적용되며,
                            <br />
                            <span
                                className="text-base font-semibold
                                    leading-[139.9999976158142%]
                                    text-text-primary"
                            >
                                우측 상단에서
                            </span>{" "}
                            자유롭게 켜고 끌 수 있어요
                        </div>
                    </div>

                    {/* Action Button */}
                    <div className="flex flex-col items-center">
                        <button
                            className="h-[54px] w-full min-w-[120px]
                                cursor-pointer rounded-small border-none
                                bg-secondary-main px-5 py-3 text-lg
                                font-semibold text-secondary-contrast
                                transition-all duration-200 ease-in-out
                                hover:bg-grey-600 dark:hover:bg-grey-500
                                md:min-w-[100px] md:px-4 md:py-2.5 md:text-lg"
                            onClick={() => {
                                router.push(
                                    "https://support.mix.day/27ddb7f5-8f0a-8020-883e-caa16894c052"
                                );
                            }}
                        >
                            자세히 알아보기
                        </button>

                        <button
                            className="mt-2.5 text-sm font-normal leading-[1.9]
                                text-text-disabled underline
                                underline-offset-[3px] md:mt-3 md:text-sm"
                            onClick={() => {
                                onHideForToday?.();
                            }}
                        >
                            일주일 동안 그만보기
                        </button>
                    </div>
                </div>
            </div>
        </MixModal>
    );
};
